//=include partials/jquery-1.11.1.min.js
//=include partials/jquery-ui.js
//=include partials/jquery-migrate.js
//=include partials/jquery.fancybox.min.js
//=include partials/jquery.arcticmodal-0.4.min.js
//=include partials/swiper.min.js
//=include partials/slick.min.js
//=include partials/timepicker.js
//=include partials/jquery.modal.min.js
//=include partials/addToCart.js
//=include partials/filter.products.js
//=include partials/scripts.js
//=include partials/locationpicker.jquery.js
